if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const container = this.querySelector('[role="document"]');
        if (!mediaId || !container) return;

        container.querySelectorAll('.product-media-modal__single-image').forEach((element) => element.remove());
        container.querySelectorAll('.active').forEach((element) => {
          element.classList.remove('active');
        });

        let activeMedia = this.buildClickedImage(mediaId);

        if (activeMedia) {
          container.appendChild(activeMedia);
        } else {
          activeMedia = Array.from(container.querySelectorAll('[data-media-id]')).find(
            (element) => element.getAttribute('data-media-id') === mediaId
          );
        }

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'center', inline: 'center' });

        const mediaWidth = activeMedia.width || activeMedia.clientWidth || container.clientWidth;
        container.scrollLeft = Math.max((mediaWidth - container.clientWidth) / 2, 0);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      buildClickedImage(mediaId) {
        const openerImage = this.openedBy?.closest('.product__modal-opener')?.querySelector('img');
        if (!openerImage) return null;

        const image = openerImage.cloneNode();
        image.removeAttribute('loading');
        image.setAttribute('data-media-id', mediaId);
        image.setAttribute('sizes', '(min-width: 750px) 92rem, 100vw');
        image.className = 'product-media-modal__single-image global-media-settings global-media-settings--no-shadow';
        image.alt = openerImage.alt || '';

        return image;
      }
    }
  );
}
